// Configuration constants for AI Form Widget

export const AI_FORM_CONFIG = {
  // Widget positioning
  DEFAULT_POSITION: 'bottom-right' as const,
  DEFAULT_OFFSET: { x: 20, y: 140 },

  // Widget appearance
  WIDGET_SIZE: 56, // pixels

  // Form field filtering
  SENSITIVE_FIELD_PATTERNS: [
    /password/i,
    /ssn/i,
    /social_security/i,
    /credit_card/i,
    /cvv/i,
    /phone/i,
    /email/i, // depending on requirements
  ] as Array<RegExp>,
} as const;
